import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

export function NewsletterSignup({ dark = false }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Almost there — check your email to confirm your subscription.");
      setEmail("");
    } catch {
      toast.error("Could not sign up. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@email.com"
        data-testid="newsletter-email"
        className={`flex-1 rounded-full px-5 py-3 text-sm outline-none border transition-colors focus:border-primary ${dark ? "bg-white/10 border-white/20 text-white placeholder:text-white/50" : "bg-white border-black/10 text-ink"}`}
      />
      <button
        type="submit"
        disabled={busy}
        data-testid="newsletter-submit"
        className="inline-flex items-center justify-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-heading font-semibold text-primary-foreground transition-transform hover:-translate-y-0.5 disabled:opacity-60"
      >
        {busy ? "Joining…" : "Join"} <Send className="h-4 w-4" />
      </button>
    </form>
  );
}
